import { Box, styled, Typography } from '@mui/material';
import colors from '../../themes/colors';
import fonts from '../../themes/fonts';

export const Container = styled(Box)(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
}));
export const Text = styled(Typography)(({ theme }) => ({
  fontFamily: fonts.Regular,
  fontSize: '13px',
  color: colors.gray,
}));
export const Title = styled(Text)(({ theme }) => ({}));
export const StatusText = styled(Text)(({ theme }) => ({
  fontFamily: fonts.MediumItalic,
  fontSize: '12px',
  color: colors.blackSecondary,
}));

const styles = {
  container: {
    fontFamily: 'AvenirNext',
  },
  body: {
    maxHeight: '500px',
    overflow: 'auto',
  },
  footerBtnIcon2: {
    width: '16px',
    height: '15px',
    backgroundSize: 'contain',
  },
  btnControl: {
    width: '130px',
  },
};

export default styles;
